/**
 * Darkens a CSS `rgb(r, g, b)` string by fixed per-channel offsets.
 * The parameter is reassigned in place to the parsed channel array, hence the union type — splitting
 * or renaming the binding would change the emitted code.
 * KNOWN BUG, preserved verbatim: a caller whose `color` prop is absent reaches `.replace` on undefined.
 */
export default function ChangeColor(color: string | string[] | undefined) {
  color = (color as string).replace(/[^\d,]/g, "").split(",");
  return `rgb(${+color[0]! - 45} , ${+color[1]! - 49} , ${+color[2]! - 51})`;
}
